export const formatDate = (dateInput: string | Date): string => {
  const d = new Date(dateInput);
  if (Number.isNaN(d.getTime())) return '';
  const m = d.getMonth() + 1;
  const day = d.getDate();
  const yr = d.getFullYear().toString().slice(-2);
  return `${m}/${day}/${yr}`;
};
